<app-spinner></app-spinner>
<div>
  <div class="modal-header rb-modal-header">
    <h4 class="modal-title font-weight-bold text-black-1">{{ title_tag }}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="activityForm" novalidate>
      <div class="row mt-3">
        <div class="col-4">
          <label for="first_name" class="text-black-1">Name</label>
        </div>
        <div class="input-group col-8">
          <input
            id="name"
            class="form-control rb-input"
            placeholder="Please enter activity name."
            formControlName="name"
            name="name"
            type="text"
          />
          <div class="col-12 error-mssg" *ngIf="(formControl.name.touched || submitted) && formControl.name.errors">
            <label for="name" class="text-danger" *ngIf="formControl.name.errors.required">*Name is required.</label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label for="description" class="text-black-1">Description</label>
        </div>
        <div class="input-group col-8">
          <textarea
            id="description"
            class="form-control rb-input"
            placeholder="Add activity description."
            formControlName="description"
            name="description"
            type="text"
          >
          </textarea>
          <div
            class="col-12 error-mssg"
            *ngIf="(formControl.description.touched || submitted) && formControl.description.errors"
          >
            <label for="description" class="text-danger" *ngIf="formControl.description.errors.required"
              >*Description is required.</label
            >
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label for="description" class="text-black-1">Upload activity icon</label>
        </div>
        <div class="input-group col-8">
          <input type="file" (change)="onActivityUploadIcon($event)" accept="image/*" />
          <div class="activityImgPreview" *ngIf="preview && preview !== null">
            <img [src]="preview" [alt]="activityForm.value.name" />
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label for="isActive" class="text-black-1" translate> Active status</label>
        </div>
        <div class="input-group col-8">
          <p-dropdown
            class="w-100-p"
            [options]="status"
            optionLabel="name"
            optionValue="value"
            formControlName="isActive"
            placeholder="Select status"
          ></p-dropdown>
          <div
            class="col-12 error-mssg"
            *ngIf="(formControl.isActive.touched || submitted) && formControl.isActive.errors"
          >
            <label for="isactive" class="text-danger" *ngIf="formControl.isActive.errors.required">
              *Please select status.
            </label>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer border-0 rb-modal-footer">
    <span class="error-danger">
      *Inorder to maintain the consistency throughout the app. Please upload black/white image. You can download the
      image from <a href="https://www.flaticon.com/search?word=" target="_blank">this link.</a>
    </span>
    <button class="btn-cancel ml-4 w-100" (click)="activeModal.close(false)" ngbAutoFocus>Cancel</button>
    <button class="btn-save ml-4 w-100" *ngIf="!isLoading" (click)="save()">Submit</button>
    <button class="btn-save ml-4 w-100" disabled *ngIf="isLoading">
      <i class="fa fa-spinner fa-spin" style="font-size: 16px"></i>
    </button>
  </div>
</div>
